import { ReportsTemplate } from "../../features/reporting/templates/ReportsTemplate";

export default function ReportsScreen() {
  return <ReportsTemplate />;
}
